/* unplugin-vue-components disabled */var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('x-address', {
    attrs: {
      "title": _vm.title,
      "list": _vm.ChinaAddressV4Data,
      "placeholder": _vm.placeholder
    },
    on: {
      "on-shadow-change": _vm.onShadowChange
    },
    model: {
      value: _vm.currValue,
      callback: function ($$v) {
        _vm.currValue = $$v;
      },
      expression: "currValue"
    }
  }, [_vm.hasTitleSlot ? _c('template', {
    slot: "title"
  }, [_vm._t("title")], 2) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };